import i18next from 'i18next';

/**
 * i18next instance.
 *
 * This module intentionally has NO local imports — only the i18next library.
 * This guarantees it can never participate in a circular dependency chain,
 * making it safe to import from any module in the codebase (notably Locales.ts).
 *
 * @see https://www.i18next.com/
 */
export const i18n = i18next;

/**
 * Is i18n ready?
 */
export let i18nReady: Readonly<boolean> = false;

let _resolver: () => void;
let _rejector: (reason?: any) => void;

/**
 * Promise that resolves when i18n is initialized.
 */
export const i18nInitialized = new Promise<void>((resolve, reject) => {
	_resolver = resolve;
	_rejector = reject;
});

/** @internal called by i18n.ts when initialization completes or fails */
export function _setI18nReady() {
	(i18nReady as boolean) = true;
}

/** @internal called by i18n.ts to resolve the initialization promise */
export function _resolveI18nInit() {
	_resolver();
}

/** @internal called by i18n.ts to reject the initialization promise */
export function _rejectI18nInit(reason?: any) {
	_rejector(reason);
}

export default i18next;
